<header class="border-border bg-card sticky top-0 z-10 flex h-[var(--app-header-height)] shrink-0 items-center gap-3 border-b px-3 sm:px-4">
    <button hlmSidebarTrigger srOnlyText="Přepnout navigaci"></button>

    <div class="bg-border h-4 w-px shrink-0" aria-hidden="true"></div>

    <h1 class="text-foreground min-w-0 flex-1 truncate text-sm font-semibold sm:text-base" [title]="title()">
        {{ title() }}
    </h1>

    <div class="flex shrink-0 items-center gap-2">
        @if (isDevelopment) {
            <span hlmBadge variant="secondary">DEV</span>
        }
        @if (isStage) {
            <span hlmBadge variant="secondary">STAGE</span>
        }
        <span class="text-muted-foreground hidden text-xs sm:inline">v{{ version }}</span>
    </div>
</header>
